import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type FieldErrorsMapper
} from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'

import type { AddAssignmentPayload } from '../constants/assignment-payload'

const fieldErrorsMapper: FieldErrorsMapper<AddAssignmentPayload> = {
  name: 'name',
  description: 'description',
  due_date: 'dueDate',
  send_to_students: 'sendToStudents',
  is_graded: 'isGraded',
  student_ids: 'studentIds',
  non_field_error: 'root'
}

const useAddAssignment = (options?: {
  onSuccess: (validData: AddAssignmentPayload) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: AddAssignmentPayload) =>
      httpService.panel.panelAssignmentsCreate({
        description: data.description,
        due_date: formatApiDate(data.dueDate),
        group: data.group,
        is_graded: data.isGraded,
        name: data.name,
        send_to_students: data.sendToStudents,
        student_ids: data.studentIds
      }),
    onSuccess: (_, variables) => options?.onSuccess?.(variables),
    fieldErrorsMapper
  })

export default useAddAssignment
